module.exports = __webpack_public_path__ + "media/images/image3-5c0d9dfd2556b576dbd1edf38d999920.png";